import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 50px;
  background-color: ${(props) => props.theme.colors.white};
`;

export const HeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const TypographyContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const HeaderRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const HeaderLeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  height: 100%;

  & > span:last-child {
    text-transform: capitalize;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const AgentSearchContainer = styled.div`
  display: flex;
  max-height: 24px;
  width: auto;

  & > div > div:nth-child(1) {
    padding: 4px;
  }

  & > div > div:nth-child(1) > div:nth-child(1) {
    display: none;
  }

  & > div > div:nth-child(2) {
    min-width: 278px;
  }
`;

